import { useEffect } from "react";

interface UseKeyboardShortcutArgs {
  key: string;
  meta?: boolean;
  onTrigger: () => void;
  enabled?: boolean;
}

export const useKeyboardShortcut = ({
  key,
  meta = true,
  onTrigger,
  enabled = true,
}: UseKeyboardShortcutArgs): void => {
  useEffect(() => {
    if (!enabled) return;
    const handler = (e: KeyboardEvent) => {
      const matchesMeta = meta ? e.metaKey || e.ctrlKey : true;
      if (matchesMeta && e.key.toLowerCase() === key.toLowerCase()) {
        e.preventDefault();
        // Holding the keys must not flap the target open and shut.
        if (!e.repeat) onTrigger();
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [key, meta, onTrigger, enabled]);
};
